module.exports = __webpack_public_path__ + "img/throwDropText3.f324f716.png";